import i18next from 'i18next';
import MainHeaderCell from 'components/common/datatable/MainHeaderCell';
import {
  cellWithTooltip,
  EADataGridCell,
} from 'components/common/datatable/EADataGrid';
import React from 'react';
import moment from 'moment/moment';
import DataTableActions from '../../../../components/common/datatable/DataTableActions';
import StatusChip from '../../../../components/common/StatusChip';
import { PrivilegeEnum } from '../../../../services/common/RolesUtils';

const contextModelTableActions = ({
  openContextModel,
  openReadContextModel,
  contextModel,
  changeModelStatus,
  deleteModel,
  hasAnyOfPrivileges
}) => {
  const isModelActive = contextModel.active;
  return [
    {
      label: i18next.t('read'),
      icon: 'open-eye',
      action: () => {
        openReadContextModel(contextModel);
      },
      isDisabled: !hasAnyOfPrivileges(
        PrivilegeEnum.PRIVILEGE_VIEW_CONTEXT_MODEL
      ),
    },
    {
      label: i18next.t('modify'),
      icon: 'edit_grey',
      action: () => {
        openContextModel(contextModel);
      },
      isDisabled: !hasAnyOfPrivileges(
        PrivilegeEnum.PRIVILEGE_EDIT_CONTEXT_MODEL_PARAMETERS
      ),
    },
    {
      label:
        isModelActive === true
          ? i18next.t('demandes.dossierModel.status.actions.disable')
          : i18next.t('demandes.dossierModel.status.actions.enable'),
      icon:
        isModelActive === true ? 'pause_circle_filled' : 'play_circle_filled',
      action: () => {
        changeModelStatus({
          contextModelId: contextModel.id,
          status: !isModelActive,
        });
      },
      isDisabled: !hasAnyOfPrivileges(
        PrivilegeEnum.PRIVILEGE_EDIT_CONTEXT_MODEL_STATUS
      ),
    },
    {
      label: i18next.t('delete'),
      icon: 'delete_grey',
      action: () => {
        deleteModel(contextModel.id);
      },
      isDisabled:
        contextModel.hasInstance ||
        !hasAnyOfPrivileges(
          PrivilegeEnum.PRIVILEGE_DELETE_CONTEXT_MODEL
        ),
    },
  ];
};

export const contextModelListColumns = ({
  openContextModel,
  openReadContextModel,
  changeModelStatus,
  deleteModel,
  hasAnyOfPrivileges
}) => {
  return [
    {
      field: 'name',
      headerName: i18next.t(
        'demandes.contextModel.contextModelListColumns.name'
      ),
      flex: 0.1,
      renderHeader: () => (
        <MainHeaderCell
          name={i18next.t('demandes.contextModel.contextModelListColumns.name')}
        />
      ),
      renderCell: (params) => cellWithTooltip(params.value),
    },
    {
      field: 'code',
      headerName: i18next.t(
        'demandes.contextModel.contextModelListColumns.code'
      ),
      flex: 0.1,
      renderHeader: () => (
        <MainHeaderCell
          name={i18next.t('demandes.contextModel.contextModelListColumns.code')}
        />
      ),
      renderCell: (params) => cellWithTooltip(params.value),
    },
    {
      field: 'creationDate',
      headerName: i18next.t(
        'demandes.contextModel.contextModelListColumns.creationDate'
      ),
      flex: 0.1,
      renderHeader: () => (
        <MainHeaderCell
          name={i18next.t(
            'demandes.contextModel.contextModelListColumns.creationDate'
          )}
        />
      ),
      renderCell: (params) =>
        cellWithTooltip(moment(params.value).format('DD/MM/YYYY')),
    },
    {
      field: 'createdBy',
      headerName: i18next.t(
        'demandes.contextModel.contextModelListColumns.createdBy'
      ),
      flex: 0.1,
      renderHeader: () => (
        <MainHeaderCell
          name={i18next.t(
            'demandes.contextModel.contextModelListColumns.createdBy'
          )}
        />
      ),
      renderCell: (params) =>
        cellWithTooltip(
          <>
            {params.value.nom} {params.value.prenom}
          </>
        ),
    },
    {
      field: 'updateDate',
      headerName: i18next.t(
        'demandes.contextModel.contextModelListColumns.updateDate'
      ),
      flex: 0.1,
      renderHeader: () => (
        <MainHeaderCell
          name={i18next.t(
            'demandes.contextModel.contextModelListColumns.updateDate'
          )}
        />
      ),
      renderCell: (params) =>
        cellWithTooltip(moment(params.value).format('DD/MM/YYYY')),
    },
    {
      field: 'updatedBy',
      headerName: i18next.t(
        'demandes.contextModel.contextModelListColumns.updatedBy'
      ),
      flex: 0.1,
      renderHeader: () => (
        <MainHeaderCell
          name={i18next.t(
            'demandes.contextModel.contextModelListColumns.updatedBy'
          )}
        />
      ),
      renderCell: (params) =>
        cellWithTooltip(
          <>
            {params.value.nom} {params.value.prenom}
          </>
        ),
    },
    {
      field: 'active',
      headerName: i18next.t('demandes.dossierModel.status.title'),
      flex: 0.1,
      headerAlign: 'center',
      align: 'center',
      type: 'singleSelect',
      valueOptions: [
        {
          value: true,
          label: i18next.t('demandes.dossierModel.status.options.active'),
        },
        {
          value: false,
          label: i18next.t('demandes.dossierModel.status.options.inactive'),
        },
      ],
      valueFormatter: (params) =>
        params.value === true
          ? i18next.t('demandes.dossierModel.status.options.active')
          : i18next.t('demandes.dossierModel.status.options.inactive'),
      renderCell: (params) => {
        return (
          <EADataGridCell tooltip={false}>
            <StatusChip
              status={params.value ? 'active' : 'inactive'}
              label={'demandes.dossierModel.status.options'}
            />
          </EADataGridCell>
        );
      },
    },
    {
      field: 'action',
      headerName: i18next.t('actions'),
      flex: 0.1,
      sortable: false,
      filterable: false,
      disableExport: true,
      hideSortIcons: true,
      disableReorder: true,
      disableColumnMenu: true,
      disableMultipleSelection: true,
      disableSelectionOnClick: true,
      isRowSelectable: false,
      hideFooterSelectedRowCount: true,
      align: 'center',
      renderCell: (params) => {
        return (
          <div className="dt" style={{ textAlign: 'center' }}>
            <DataTableActions
              actions={contextModelTableActions({
                openContextModel,
                openReadContextModel,
                contextModel: params.row,
                changeModelStatus,
                deleteModel,
                hasAnyOfPrivileges
              })}
            />
          </div>
        );
      },
    },
  ];
};
